// src/styles.css.js
export const CHAT_STYLES = `
.attraxion-chat-bubble {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 4px 14px rgba(0,0,0,.25);
  color: #fff;
}

.attraxion-chat-panel iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

@media (max-width: 640px) {
  .attraxion-chat-panel {
    width: calc(100vw - 40px) !important;
    height: calc(100vh - 40px) !important;
  }
}
`;
